<template>
  <div class="notice-container">
    <div v-for="(item, index) in noticeList" :key="index" class="notice-item"  @click="openDetail(item)">
      <div class="notice-date">
        {{ formatDate(item.start_date) }}
      </div>
      <div class="notice-title">
        {{ item.title }}
      </div>
      <div class="notice-arrow">
        <img src="/img/menu_right.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    noticeList: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return '';
      const dt = new Date(date);
      return `${dt.toLocaleDateString('ja-JP', { month: '2-digit', day: '2-digit', year: '2-digit' })} ${dt.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' })}`;
    },
    openDetail(item) {
      this.$emit('openDetail', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.notice-container {
  width: 100%;
  max-width: 600px;
  margin: 10px auto;
  background: white;
}
.notice-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 6px;
  border-bottom: 1px solid #ddd;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #f5f5f5;
  }
}

.notice-date {
  white-space: nowrap;
  width: 30%;
  color: #666;
  @media screen and (max-width: $tabletWidth) {
    font-size: smaller;
  }
  padding-right: 5px;
}
.notice-title {
  flex-grow: 1;
  color: #666;
  text-align: left;
}

.notice-arrow {
  transition: transform 0.2s;
  &:hover {
    transform: translateX(3px);
  }
  img{
    width: 30px;
    height: 30px;
  }
}
</style>
